export const NEW_ESTIMATE_SCOPE_NOTE_DRAFT_ID = "new-estimate";

type ExistingEstimateScopeNoteDraftId = `existing-estimate:${string}`;

interface ScopeNoteDraftStorageParams {
  userId?: string;
  organizationId?: string;
  draftId: string;
}

const SCOPE_NOTE_DRAFT_STORAGE_PREFIX = "rebuild:scope-note-draft";

export function getExistingEstimateScopeNoteDraftId(estimateId: string): ExistingEstimateScopeNoteDraftId {
  return `existing-estimate:${estimateId}`;
}

export function getScopeNoteDraftStorageKey({ userId, organizationId, draftId }: ScopeNoteDraftStorageParams) {
  if (!userId || !organizationId) {
    return undefined;
  }

  return `${SCOPE_NOTE_DRAFT_STORAGE_PREFIX}:${organizationId}:${userId}:${draftId}`;
}

export function readScopeNoteDraft(params: ScopeNoteDraftStorageParams) {
  const key = getScopeNoteDraftStorageKey(params);
  if (!key) {
    return undefined;
  }

  try {
    return window.localStorage.getItem(key) ?? undefined;
  } catch {
    return undefined;
  }
}

export function writeScopeNoteDraft(params: ScopeNoteDraftStorageParams, text: string) {
  const key = getScopeNoteDraftStorageKey(params);
  if (!key) {
    return;
  }

  try {
    if (!text.trim()) {
      window.localStorage.removeItem(key);
      return;
    }

    window.localStorage.setItem(key, text);
  } catch {
    // localStorage can be unavailable in private browsing or locked-down webviews.
  }
}

export function clearScopeNoteDraft(params: ScopeNoteDraftStorageParams) {
  const key = getScopeNoteDraftStorageKey(params);
  if (!key) {
    return;
  }

  try {
    window.localStorage.removeItem(key);
  } catch {
    // localStorage can be unavailable in private browsing or locked-down webviews.
  }
}
